import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSpecificWorkspace } from '../actions/workspaceAction';
import { PermissionProvider } from '../pages/authentication/permission-providor/context/PermissionProvider';
import LoadingOverlay from '../components/LoadingOverlay';

const WorkspaceRoute = ({ children }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const workspaceID = localStorage.getItem("workspaceID");
  const workspaceInfo = useSelector((state) => state.workspace.workspaceInfo);

  useEffect(() => {
    const fetchWorkspace = async () => {
      if (workspaceID  && !workspaceInfo?.data) {
        try {
          await dispatch(getSpecificWorkspace(workspaceID));
        } finally {
          setLoading(false);
        }
      }
    };
    fetchWorkspace();
  }, [workspaceID, workspaceInfo, dispatch]);

  if (loading) return <LoadingOverlay />;

  return (
    <PermissionProvider>
      {children}
    </PermissionProvider>
  );
};

export default WorkspaceRoute;